import React, { FC, useState } from 'react';
import { useGetPayload } from '~/controllers/wizard';
import ManagersTable, {
  getManagersData,
} from '~/pages/ksa/application/managers/components/ManagersTable';
import ManagerReviewEdit from '~/pages/ksa/review/managers/components/ManagerReviewEdit';
import { FormItemInjectedProps } from '~/types/FormItemInjectedProps';
import { KsaManagers } from '~/types/ksa/KsaManagers';

const ManagersReviewTableForm: FC<Partial<FormItemInjectedProps<KsaManagers>>> = (props) => {
  const payload = useGetPayload();

  const [editUid, setUid] = useState<string>('');
  const openEdit = (uid: string) => {
    setUid(uid);
  };
  const closeEdit = () => {
    setUid('');
  };

  const managersDataSource = getManagersData(payload, openEdit);

  return (
    <>
      {editUid && <ManagerReviewEdit uid={editUid} onClose={closeEdit} {...props} />}
      <ManagersTable managers={managersDataSource} />
    </>
  );
};

export default ManagersReviewTableForm;
